export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["Primary"] = "primary";
    ButtonVariant["Secondary"] = "secondary";
})(ButtonVariant || (ButtonVariant = {}));
export var ButtonIconPosition;
(function (ButtonIconPosition) {
    ButtonIconPosition["Left"] = "iconPositionLeft";
    ButtonIconPosition["Right"] = "iconPositionRight";
})(ButtonIconPosition || (ButtonIconPosition = {}));
export var ButtonSize = {
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
};
export var OutlineButtonVariant;
(function (OutlineButtonVariant) {
    OutlineButtonVariant["Primary"] = "outlinePrimary";
    OutlineButtonVariant["Secondary"] = "outlineSecondary";
    OutlineButtonVariant["Inverse"] = "outlineInverse";
})(OutlineButtonVariant || (OutlineButtonVariant = {}));
export var DropdownButtonVariant;
(function (DropdownButtonVariant) {
    DropdownButtonVariant["Primary"] = "dropdownPrimary";
    DropdownButtonVariant["Secondary"] = "dropdownSecondary";
})(DropdownButtonVariant || (DropdownButtonVariant = {}));
export var IconButtonVariant;
(function (IconButtonVariant) {
    IconButtonVariant["Square"] = "square";
    IconButtonVariant["SquareFilled"] = "squareFilled";
    IconButtonVariant["Plain"] = "plain";
    IconButtonVariant["Circle"] = "circle";
    IconButtonVariant["CircleFilled"] = "circleFilled";
    IconButtonVariant["Inverse"] = "inverse";
    IconButtonVariant["InverseFilled"] = "inverseFilled";
})(IconButtonVariant || (IconButtonVariant = {}));
export var TextButtonVariant;
(function (TextButtonVariant) {
    TextButtonVariant["Default"] = "text";
    TextButtonVariant["Inverse"] = "textInverse";
})(TextButtonVariant || (TextButtonVariant = {}));
export var DeprecatedButtonVariant;
(function (DeprecatedButtonVariant) {
    DeprecatedButtonVariant["Primary"] = "deprecatedPrimary";
    DeprecatedButtonVariant["Secondary"] = "deprecatedSecondary";
    DeprecatedButtonVariant["Delete"] = "deprecatedDelete";
})(DeprecatedButtonVariant || (DeprecatedButtonVariant = {}));
